//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('requisitionsBetween', {
//        templateUrl: 'views/components/views/requisitionsBetween/requisitionsBetween.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'requisitionsBetweenService', 'logisticService', 'rememberService', function (stateService, utilityService, requisitionsBetweenService, logisticService, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let variableNames = {
//                businessco_no_from: '',
//                stockplace_id_from: ''
//            };

//            vm.model = {
//                bgRequisitionsBetweenListType: {
//                    selected: 'NEW',
//                    buttons: [
//                        { id: 'NEW', label: 'bg_requisitionsbetween_listtype_create', color: 'primary', onClick: () => vm.model.bgRequisitionsBetweenListType.selected = 'NEW' },
//                        { id: 'IN_PROGRESS', label: 'bg_requisitionsbetween_listtype_in_progress', color: 'primary', onClick: () => vm.model.bgRequisitionsBetweenListType.selected = 'IN_PROGRESS' }
//                    ]
//                },
//                setting: {},
//                selectListCompanies: [],
//                selectListStockPlaces: [],
//                itemsListRequisitionsBetween: [],
//                itemsListRequisitionsBetweenConsignment: []
//            };

//            // #region VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await requisitionsBetweenService.getSetting())[0];
//            }
            
//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }
            
//            async function loadStockPlaces() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no_from) !== true) return;

//                return vm.model.selectListStockPlaces = await logisticService.listStocks({
//                    businessco_no: vm.model.setting.businessco_no_from,
//                    add_all: 'ALL'
//                });
//            }
            
//            async function loadRequisitionsBetween() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no_from) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id_from, true) !== true) return;

//                return vm.model.itemsListRequisitionsBetween = await requisitionsBetweenService.listRequisitionsBetween(vm.model.setting);
//            }
            
//            async function loadRequisitionsBetweenConsignment() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no_from) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id_from, true) !== true) return;
                
//                return vm.model.itemsListRequisitionsBetweenConsignment = await requisitionsBetweenService.listRequisitionsBetweenConsignment(vm.model.setting);
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'businessco_no_from':
//                    case 'stockplace_id_from':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region BUTTON GROUP SINGLE FUNCTION

//            vm.selectBgRequisitionsBetweenListType = function (value) {
//                vm.model.bgRequisitionsBetweenListType.selected = value;
//            }

//            // #endregion BUTTON GROUP SINGLE FUNCTION

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no_from':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no_from) !== true) return;

//                        vm.model.setting.businessco_no_from = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no_from) !== true) return;

//                        Promise.all([
//                            rememberFunc('businessco_no_from')
//                        ]).then(() => {
//                            loadStockPlaces();
//                            loadRequisitionsBetween();
//                            loadRequisitionsBetweenConsignment();
//                            Promise.resolve();
//                        });
//                        break;
//                    case 'stockplace_id_from':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.stockplace_id_from) !== true) return;

//                        vm.model.setting.stockplace_id_from = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.stockplace_id_from) !== true) return;

//                        Promise.all([
//                            rememberFunc('stockplace_id_from')
//                        ]).then(() => {
//                            loadRequisitionsBetween();
//                            loadRequisitionsBetweenConsignment();
//                            Promise.resolve();
//                        });
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadCompanies();

//                return Promise.all([
//                    loadStockPlaces()
//                ]).then(() => {
//                    loadRequisitionsBetween();
//                    loadRequisitionsBetweenConsignment();
//                    Promise.resolve();
//                });
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
